import { observer } from "mobx-react";
import React from "react";
import PoolStore from "stores/PoolStore";
import Button from "components/Button/Button";
import { FarmingPool, FarmingPoolData } from "types";
import Ram from "../../Ram";
import "./UserSection.scss";

type Props = {
  pool: FarmingPool;
  data: FarmingPoolData;
};

function UserSection({ pool, data }: Props) {
  const elmnt = document.getElementById("section-ram-user");
  const width = (elmnt && elmnt.offsetWidth) || 0;

  const { stake, earned, bonusStake, yields, totalSupply, multiplier } = data;

  const APY = yields.yearlyROI;
  const stakingTokenName = pool.stakingToken.name;

  const shareOfTotal = stake / totalSupply;

  return (
    <div className="section-user">
      <div className="section-title section-title-user">user statistics</div>
      <div id="section-ram-user" className="section-ram">
        {<Ram transformValue={Math.min(80, APY)} parentWidth={width} />}
        <div className="apy">APY {APY && !isNaN(APY) ? parseFloat(APY).toFixed(0) : "TBA"}%</div>
      </div>
      <div className="reward-container">
        <div className="reward-statuses">
          <div className="section-item top-level-item">
            <div className="section-item-title">
              rewards
              <br /> <span className="section-item-value">{earned.toFixed(4)}</span> {pool.rewardToken.name}
            </div>
          </div>
        </div>
        <Button
          type="normal"
          className={`interaction-button top-level-item ${!earned && "disabled"}`}
          onClick={() => earned > 0 && PoolStore.claim(pool)}
        >
          Claim rewards
        </Button>
      </div>
      <div className="section-item top-level-item">
        <div className="section-item-title">staked</div>
        <div className="section-item-value">
          {stake.toFixed(8)}
          <span className="staked-percent">({shareOfTotal && !isNaN(shareOfTotal) ? shareOfTotal.toFixed(2) : 0}%)</span>
          <div style={{ fontSize: "12px" }}>{stakingTokenName}</div>
        </div>
      </div>
      <div className="section-item top-level-item">
        <div className="section-item-title">boost ({multiplier}%)</div>
        <div className="section-item-value">
          <div className="section-item-value">{bonusStake?.toFixed(8)}</div>
          <div style={{ fontSize: "12px" }}>{stakingTokenName}</div>
        </div>
      </div>
    </div>
  );
}

export default observer(UserSection);
